import React, { useState } from "react";
import * as S from "./styles";

import ReactHtmlParser from 'react-html-parser'
import Tooltip from "src/components/Tooltip";

function Item({ item, index }) {
  const [showTooltip, setShowToolip] = useState(false)
	const { image, title, description, titleColor, textColor } = item;

  const hasSpanToClick = description.includes('<span>') && index === 0

  const textWithIcon = (text) => {
		return text.replace('{icon}', '<img src="/bradescoclassic/assets/info_icon.png" />')
	}

  function handleTooltip() {
    if(hasSpanToClick) setShowToolip(!showTooltip)
  }

	return (
    <S.Container>
      <S.Image>
        <img
          src={`https://${image.fields.file.url}`}
          alt={image.fields.title}
        />
      </S.Image>
      <S.Content onClick={handleTooltip} hasTooltip={hasSpanToClick}>
        <S.Title color={'#230C87'}>{title}</S.Title>
        <S.Description color={'#230C87'}>
          {ReactHtmlParser(textWithIcon(description))}
        </S.Description>
        {showTooltip && (
          <S.ToolTipContainer>
            <Tooltip width='500px' title='A recarga automática é uma facilidade para você nunca ficar sem saldo!' description='Você escolhe o valor para sua primeira recarga, a partir de R$50.
            Sempre que o saldo da conta chegar em 30%, nós recarregaremos automaticamente
            no cartão cadastrado.' />
          </S.ToolTipContainer>
        )}
      </S.Content>
      {index === 2 && (
        <S.ContainerFooter>
          <S.LinkFooter href='https://veloe.com.br/onde-usar/mapa/' target='blank'>
            Ver cobertura
          </S.LinkFooter>
        </S.ContainerFooter>
      )}
    </S.Container>
	);
}

export default Item;
